import React, { useState, useEffect } from "react";

const FlavourCard3D = ({ item, width, height, onClick }) => {
  const [hover, setHover] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Determine device type
  const isMobile = screenWidth < 400;
  const isSmallTablet = screenWidth >= 400 && screenWidth < 768;
  const isTablet = screenWidth >= 768 && screenWidth < 1024;
  const isDesktop = screenWidth >= 1024;

  // Calculate character transform based on device
  const getCharacterTransform = () => {
    if (!hover) return "none";
    
    if (isMobile) {
      return "translate3d(0%, -30%, 100px)";
    } else if (isSmallTablet) {
      return "translate3d(0%, -20%, 100px)"; // Less movement for 400-768px
    } else if (isTablet) {
      return "translate3d(0%, -15%, 100px)";
    } else {
      return "translate3d(0%, -15%, 100px)"; // Desktop
    }
  };

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width,
        height,
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-end",
        perspective: "2500px",
        flexShrink: 0,
        cursor: "pointer",
      }}
    >
      {/* Background image with 3D effect */}
      <div
        style={{
          transition: "all 0.5s",
          position: "absolute",
          width: "100%",
          height: "100%",
          zIndex: -1,
          transform: hover
            ? "perspective(900px) translateY(-5%) rotateX(25deg)"
            : "none",
          borderRadius: 12,
          overflow: "hidden",
        }}
      >
        <img
          src={item?.image_url}
          alt={item?.flavour_name}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: 12,
          }}
        />

        {/* Gradient overlays */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            opacity: hover ? 1 : 0,
            backgroundImage: "linear-gradient(to top, transparent 46%)",
            transition: "all 0.5s",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: hover ? 100 : 80,
            opacity: 1,
            backgroundImage: "linear-gradient(to bottom, transparent 46%)",
            transition: "all 0.5s",
            borderRadius: 12,
          }}
        />
      </div>

      {/* Character image */}
      <img
        src={item?.character_url || item?.image_url}
        alt="character"
        style={{
          width: "100%",
          height: "auto",
          position: "absolute",
          bottom: "0%",
          zIndex: 2,
          objectFit: "contain",
          opacity: hover ? 1 : 0,
          transform: getCharacterTransform(),
          transition: "all 0.5s ease",
          pointerEvents: "none",
          borderRadius: 12,
        }}
      />
    </div>
  );
};

export default FlavourCard3D;